import type { ReactNode } from "react";
import { Text } from "@ferrivia/ui";
import { WhyWeAsk } from "./WhyWeAsk";
import s from "./StepLayout.module.css";

export interface StepLayoutProps {
  title: string;
  subtitle?: string;
  why?: string;
  children: ReactNode;
}

/** Heading, optional reason, optional explainer link, then the answer. */
export function StepLayout({ title, subtitle, why, children }: StepLayoutProps) {
  return (
    <div className={s.root}>
      <Text as="h1" size="2xl" weight="bold" className={s.title}>
        {title}
      </Text>
      {subtitle ? (
        <Text as="p" size="md" className={s.subtitle}>
          {subtitle}
        </Text>
      ) : null}
      {why ? <WhyWeAsk>{why}</WhyWeAsk> : null}
      <div className={s.body}>{children}</div>
    </div>
  );
}
